export default "__VITE_ASSET__DzIA0gYT__"